<fwc-pagination
  [attr.model]="model"
  label-aria-nav="Pagination1"
  label-aria-next="Next Page"
  label-aria-prev="Previous Page"
  (fwc-pagination-update)="updateActivePagination($event)"
></fwc-pagination>
